/**
 * TIPOS ESCONDIDOS DO SELECT DE TIPOS DA BUSCA — por codsite.
 *
 * O select vem da query `tipos` do site-graphql (`listTipos`), que devolve os tipos
 * DISTINCT dos imóveis publicados do tenant. Como `tbl_imovel_tipo` é quase toda
 * global (`CodSite = 0`), a imobiliária não consegue "apagar" um tipo pelo CRM: ele
 * volta no próximo imóvel cadastrado, e apagar de verdade tiraria o tipo dos outros
 * ~300 sites. Daí o mapa aqui — hardcode auditável num arquivo só, no molde de
 * `utils/site2524WhatsApp.ts` e do `site-espelho.ts` da API.
 *
 * ⚠️ Escopo: SÓ as OPÇÕES do select (o que o visitante escolhe). A lista COMPLETA
 * continua valendo para:
 *   - resolver o tipo que vem na URL em /imoveis (`GetInitialFilters`), senão um link
 *     antigo `/imoveis/venda/canoas/-/-/Casa` deixaria de filtrar e listaria tudo;
 *   - os links de "pesquisas populares" do rodapé (`AboutPieces` → `cities_types`);
 *   - o sitemap `all_tipos.xml` (`arrumaUrlTiposSiteMaps`).
 * O imóvel de um tipo escondido continua publicado e aparecendo na listagem geral.
 *
 * cs93 (J. Fernando Imóveis — jfernandoimoveis.com.br), pedido do cliente em 01/09/2026:
 * o cadastro acumulou variações do mesmo tipo ("Kit Net" × "Kitnet", três galpões,
 * "Casa Sobrado" × "Sobrado") e a imobiliária quis um select curto, só com os nomes
 * que ela usa hoje. Escolhas ambíguas confirmadas pelo Daniel na abertura da demanda.
 */
export const TIPOS_OCULTOS_BUSCA: Record<number, number[]> = {
    93: [
        352074, // Andar Comercial
        17,     // Área de Terra            (ficam "Área" 50177 e "Área Industrial" 87137)
        2737,   // Box Garagem
        2,      // Casa                     (fica "Casa Residencial" 2921)
        2761,   // Casa Sobrado             (fica "Sobrado" 4)
        2759,   // Chácara Sítio
        4321,   // Cobertura Duplex         (fica "Cobertura" 2928)
        2816,   // Condomínio Fechado
        2800,   // Galpão Depósito Pavilhão (fica "Deposito - Galpão - Pavilhão" 3792)
        48885,  // Galpão-Pavilhão
        563,    // Kit Net                  (fica "Kitnet" 74356)
        2546,   // Pavilhão
        88389,  // Ponto Comercial
        2757,   // Prédio
        569,    // Residência e Comércio
        2924,   // Sítio
    ],
    // cs834 (Cecília Imóveis — ceciliaimoveis.com.br), pedido da cliente em 19/10/2026.
    // "Chácara Sítio" (2759) fica: o pedido foi só "Sítio".
    834: [
        2930,   // Apartamento Com Terraço  (fica "Apartamento" 1)
        2929,   // Apartamento Mobiliado
        2761,   // Casa Sobrado             (fica "Casa" 2)
        4321,   // Cobertura Duplex         (fica "Cobertura" 2928)
        2924,   // Sítio
        4,      // Sobrado
    ],
};

/**
 * Tira da lista de opções os tipos escondidos deste site. Fora do mapa devolve a MESMA
 * referência — os outros sites não pagam nada por isso.
 */
export function filtrarTiposDoSelect(opcoes: Array<any>, codsite: unknown): Array<any> {
    const ocultos = TIPOS_OCULTOS_BUSCA[Number(codsite) || 0];
    if (!ocultos?.length || !opcoes?.length) return opcoes || [];
    return opcoes.filter((opcao: any) => !ocultos.includes(Number(opcao?.value)));
}
